import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { errorIcon, infoIcon, successIcon, warningIcon } from '@lululemon/ecom-pattern-library-icons';
import cs from 'classnames';
import { Icon } from '@lululemon/ecom-pattern-library-icon';
import styles from './index.module.scss.js';

var _excluded = ["children", "className", "type", "visible", "icon"];
var Notification = _ref => {
  var {
      children,
      className,
      type,
      visible,
      icon
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var roleValue = type === 'error' || type === 'warning' ? 'alert' : 'status';
  var iconContent = {
    error: errorIcon,
    info: infoIcon,
    success: successIcon,
    warning: warningIcon,
    message: infoIcon
  };
  var iconContentValue = !icon ? iconContent[type] : icon;
  return /*#__PURE__*/React.createElement("div", {
    role: roleValue
  }, visible ? /*#__PURE__*/React.createElement("div", _extends({
    className: cs(styles.notificationBlock, className, {
      [styles.errorNotification]: type === 'error',
      [styles.infoNotification]: type === 'info',
      [styles.successNotification]: type === 'success',
      [styles.warningNotification]: type === 'warning',
      [styles.messageNotification]: type === 'message'
    })
  }, otherProps), /*#__PURE__*/React.createElement(Icon, {
    content: iconContentValue,
    className: styles.iconBlock
  }), /*#__PURE__*/React.createElement("div", null, children)) : null);
};
var propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning', 'message']),
  /** Prop to control whether or not the content within the Notification is rendered */
  visible: PropTypes.bool,
  icon: PropTypes.node
};
var defaultProps = {
  className: null,
  type: 'info',
  visible: false,
  icon: null
};
Notification.propTypes = propTypes;
Notification.defaultProps = defaultProps;

export { Notification, defaultProps, propTypes };
//# sourceMappingURL=index.js.map
